// extracted by mini-css-extract-plugin
module.exports = {"header":"DispatchShowMapContainer_header__3q4w7","map":"DispatchShowMapContainer_map__2ZQNo"};